/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/SvgIcon/index.vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d2a0bc5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "icon-body"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-search el-input__icon"
}, null, -1));
const _hoisted_3 = {
  class: "icon-list"
};
const _hoisted_4 = ["onClick"];
import icons from './requireIcons';
export default {
  __name: 'index',
  emits: ['selected'],
  setup(__props, {
    expose,
    emit
  }) {
    const iconName = ref('');
    const iconList = ref(icons);
    function filterIcons() {
      iconList.value = icons;
      if (iconName.value) {
        iconList.value = icons.filter(item => item.indexOf(iconName.value) !== -1);
      }
    }
    function selectedIcon(name) {
      emit('selected', name);
      document.body.click();
    }
    const filterClick = e => {
      e.preventDefault();
    };
    function reset() {
      iconName.value = '';
      iconList.value = icons;
    }
    expose({
      reset
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_svg_icon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: _unref(iconName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(iconName) ? iconName.value = $event : null),
        style: {
          "position": "relative"
        },
        clearable: "",
        placeholder: "请输入图标名称",
        onClear: filterIcons,
        onInput: filterIcons,
        onClick: filterClick
      }, {
        suffix: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(iconList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => selectedIcon(item)
        }, [_createVNode(_component_svg_icon, {
          "icon-class": item,
          style: {
            "height": "30px",
            "width": "16px"
          }
        }, null, 8, ["icon-class"]), _createElementVNode("span", null, _toDisplayString(item), 1)], 8, _hoisted_4);
      }), 128))])]);
    };
  }
};